module.exports = __webpack_public_path__ + "img/studies_rubincool_01.e036ad2d.png";